module.exports = __webpack_public_path__ + "static/media/banner_02_lg.802c7643.jpg";